import settings from '../../../config/settings';
import axios from '../api/axios';
import humps from 'humps';
import qs from 'qs';
import _ from 'lodash';

export default class UserApi {
  static getUserCheckin(id) {
    return axios.get(`${settings.apiBaseURL}/checkins/${id}`);
  }

  static getUserCheckins(query) {
    const q = humps.decamelizeKeys(_.omitBy(query, p => !p));

    return axios.get(`${settings.apiBaseURL}/checkins?${qs.stringify(q)}`);
  }
}



// WEBPACK FOOTER //
// ./shared/checkins/api.js